module.exports = __webpack_public_path__ + "media/images/map-icons/google-roadmap-43fc44d4c1aca3baa3d0eaa82a582009.png";